import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Col } from "react-bootstrap";
import Loader from "../../Shared/Loader";

import {
  Container,
  CheckoutTitle,
  SubscriptionCycle,
  OrderDetailsContainer,
  PlanRow,
  SubscriptionLabel,
  OrderButton,
  SwitchPlan,
} from "./index.style";
import {
  checkoutSubscriptions,
  reattemptPayment,
  getSubscriptions,
} from "../../../redux/middleware/subscription";
import Utils from "../../../lib/utils";

const checkoutData = (selectedCycle) => {
  const cart = Utils.getCart();
  const { company: companyInfo } = cart;
  const { paymentMethod, plan, latestInvoiceId } = cart;

  if (cart.latestInvoiceId) {
    return {
      payment_method: { id: paymentMethod.id },
      invoice_params: { id: latestInvoiceId },
    };
  }

  const paymentId = {
    id: paymentMethod.id,
  };
  const subscription = {
    product_id: plan.id,
    cycle: selectedCycle,
  };
  const company = {
    name: companyInfo.name,
    street_address_1: companyInfo.address1,
    street_address_2: companyInfo.address2,
  };

  return {
    payment_method: paymentId,
    subscription,
    company,
  };
};

const Checkout = ({
  checkoutSubscriptions,
  checkout,
  notify,
  pending,
  history,
  reattemptPayment,
  subscriptions,
  getSubscriptions,
  userSubscription,
}) => {
  useEffect(() => getSubscriptions(), []);

  const cart = Utils.getCart();
  const plan = cart && cart.plan;

  // check if the user is signed up, else go to signed page
  if (!Utils.isSignedIn()) history.push("/employer-signup");
  if (
    (plan && plan.subscribed) ||
    (userSubscription && userSubscription.status === "active")
  )
    history.push("/profiles");
  if (!Utils.getCart().paymentMethod) history.push("/payment");

  const checkProps = useRef(true);
  useEffect(() => {
    if (checkProps.current) {
      checkProps.current = false;
      return;
    }
  }, [checkout, subscriptions]);

  const [selectedCycle, setCycle] = useState("monthly");
  const [price, setPrice] = useState(plan && plan.monthly_price);
  const [contacts, setContacts] = useState(plan && plan.contact_credits);
  const [subscription, setSubcription] = useState(plan && plan.name);
  const [shownNotification, setShownNotification] = useState(true);
  const active = { background: "#39b54a", color: "white" };

  const changeCycle = (cycle) => {
    setCycle(cycle);
    if (cycle === "monthly") {
      setPrice(plan && plan.monthly_price);
    }
    if (cycle === "yearly") {
      setPrice(plan.yearly_price);
    }
  };

  const processPayment = () => {
    const data = checkoutData(selectedCycle);
    setShownNotification(false);
    if (cart.latestInvoiceId) {
      reattemptPayment(data);
    } else {
      checkoutSubscriptions(data);
    }
  };

  if (!shownNotification && checkout && !pending) {
    if (checkout.subscription) {
      if (checkout.subscription.retry) {
        const newCart = {
          ...cart,
          latestInvoiceId: checkout.subscription.latest_invoice.id,
        };
        Utils.setCart(newCart);
        history.push("payment");
      }
      notify("success", checkout.message);
      const currentCart = Utils.getCart();
      const newCart = {
        ...currentCart,
        plan: {
          ...currentCart.plan,
          subscribed: true,
        },
      };
      Utils.setCart(newCart);
      history.push("/profiles");
    }
    if (checkout.response) {
      notify(
        "error",
        checkout.response.data.message || "Your card was declined"
      );
      history.push("payment");
    }
    setShownNotification(true);
  }

  const changeSubscription = () => {
    let newCart = {};
    if (subscription.indexOf("Standard") > -1) {
      newCart = {
        ...Utils.getCart(),
        plan: subscriptions.find(
          (sub) => sub.name.indexOf("Professional") > -1
        ),
      };
      setSubcription();
    } else {
      newCart = {
        ...Utils.getCart(),
        plan: subscriptions.find((sub) => sub.name.indexOf("Standard") > -1),
      };
    }
    Utils.setCart(newCart);
    const cart = Utils.getCart();
    const plan = cart && cart.plan;
    if (selectedCycle === "monthly") setPrice(plan && plan.monthly_price);
    if (selectedCycle === "yearly") setPrice(plan && plan.yearly_price);
    setContacts(plan && plan.contact_credits);
    setSubcription(plan && plan.name);
    notify("info", `You are now on ${plan && plan.name}`);
  };

  return (
    <Container>
      <CheckoutTitle> Order Summary </CheckoutTitle>
      <SubscriptionCycle>
        <a
          style={selectedCycle === "monthly" ? active : {}}
          href="#/#"
          onClick={() => changeCycle("monthly")}
        >
          Monthly
        </a>
        <a
          style={selectedCycle === "yearly" ? active : {}}
          href="#/#"
          onClick={() => changeCycle("yearly")}
        >
          Yearly
        </a>
      </SubscriptionCycle>
      <OrderDetailsContainer>
        <PlanRow>
          <Col md={3} xs={3}>
            <i className="fa fa-briefcase" aria-hidden="true" /> Plan
          </Col>
          <Col md={5} xs={5}>
            <SubscriptionLabel> {subscription} </SubscriptionLabel>
          </Col>
          <Col md={4} xs={4}>
            <SwitchPlan onClick={changeSubscription} href="#">
              Change
            </SwitchPlan>
          </Col>
        </PlanRow>
        <PlanRow>
          <Col md={8} xs={8}>
            <i className="fa fa-envelope" /> Contacts Credits
          </Col>
          <Col md={4} xs={4}>
            <strong>{contacts}</strong>
          </Col>
        </PlanRow>
        <PlanRow>
          <Col md={8} xs={8}>
            Total Price
          </Col>
          <Col md={4} xs={4}>
            <strong>{Utils.currencyFormatter(price.slice(0,3))}</strong>
          </Col>
        </PlanRow>
        <OrderButton onClick={processPayment} disabled={pending}>
          {!pending && "Subscribe"}
          <Loader width="25px" height="25px" show={pending} />
        </OrderButton>
      </OrderDetailsContainer>
    </Container>
  );
};

const mapStateToProps = (state) => ({
  checkout: state.subscription.checkout,
  pending: state.subscription.pending,
  subscriptions: state.subscription.subscriptions,
  userSubscription: state.subscription.userSubscription,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      checkoutSubscriptions,
      reattemptPayment,
      getSubscriptions,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Checkout);
